import { ChangeDetectionStrategy, Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
export class ConfirmPopData {
  public title = 'Confirm';
  public message = 'Are you sure?';
  public cancelButtonText = 'Cancel';
  public okButtonText = 'Confirm';
  public okClassName: 'btn-success' | 'btn-warning' | 'btn-error' = 'btn-success';
  public secondaryButtons?: { name: string; class_name: string; value: string }[] = [];
  public cancelType: 'button' | 'icon' = 'button';
}

@Component({
  selector: 'app-confirm-pop',
  templateUrl: './confirm-pop.html',
  styleUrls: ['./confirm-pop.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmPopComponent implements OnInit {
  public readonly confirmTitle = signal('');
  public readonly confirmMessage = signal('');
  public readonly okButtonText = signal('');
  public readonly cancelButtonText = signal('');
  public readonly okClassName = signal('');
  public readonly secondaryButtons = signal<{ name: string; class_name: string; value: string }[]>([]);
  public readonly cancelType = signal<'button' | 'icon'>('button');

  public constructor(
    private readonly dialogRef: MatDialogRef<ConfirmPopComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: ConfirmPopData
  ) {}

  public ngOnInit(): void {
    this.confirmTitle.set(this.data.title || 'Confirm');
    this.confirmMessage.set(this.data.message || 'Are you sure?');
    this.cancelButtonText.set(this.data.cancelButtonText || 'Cancel');
    this.okButtonText.set(this.data.okButtonText || 'Confirm');
    this.okClassName.set(this.data.okClassName || 'btn-success');
    this.secondaryButtons.set(
      ((this.data.secondaryButtons || [])?.length === 0 ? [] : this.data.secondaryButtons) || []
    );
    this.cancelType.set(this.data.cancelType || 'button');
  }

  public cancelClick(): void {
    this.dialogRef.close(false);
  }

  public okClick(): void {
    this.dialogRef.close(true);
  }

  public secondarybuttonClick(btn: any): void {
    this.dialogRef.close(btn.value);
  }
}
